export default __webpack_public_path__ + "static/media/3.98dc3ce6.png";